<template>
    <div class="adminUserList">
        <Breadcumb :title="$t('administered_survey')" :actions="pageActions" :breadcumb-data="breadcumbData">
        </Breadcumb>
        <b-card no-body class="cardcontainer">
            <b-card-body>
                <p v-html="$t('provider_explain')">
                
                </p>
                <b-table
                        :items="surveysData"
                        :fields="fields"
                        :striped="true"
                        :bordered="true"
                        class="card-table">
                    
                    <template :slot="$t('label')" slot-scope="data">
                        {{data.item.label}}
                    </template>
                    <template :slot="$t('survey_type')" slot-scope="data">
                        <b-badge variant="outline-default" v-if="data.item.type === 'grouplocal'" v-html="$t('group_survey_specificities')"></b-badge>
                        <b-badge variant="outline-default" v-if="data.item.type === 'group'" v-html="$t('group_baro')"></b-badge>
                    </template>
                    <template :slot="$t('publication_date')" slot-scope="data">
                        {{ data.item.publication_date|formatDateNoH }} -  {{ data.item.publication_end|formatDateNoH }}
                    </template>
                    <template :slot="$t('language')" slot-scope="data">
                        <b-btn v-on:click="languages=data.item.language; $refs.languagemodal.open()" variant="default btn-xs md-btn-flat">
                            <i class="ion ion-md-git-network"></i>
                        </b-btn>
                    </template>
                    <template :slot="$t('raw_result')" slot-scope="data">
                        <b-btn v-on:click="downloadTemplate(data.item.id)" variant="default btn-xs md-btn-flat">
                            Template
                        </b-btn>
                        <b-btn v-on:click="survey_id=data.item.id; $refs.formodal.open()" variant="default btn-xs md-btn-flat">
                            {{ $t('load_data') }}
                        </b-btn><br/>
                        <b-badge variant="outline-danger" v-if="data.item.rawresults_date === null">{{ $t('unsubmitted_result')}}</b-badge>
                        <b-badge variant="outline-success" v-if="data.item.rawresults_date">{{ $t('submitted_the')}} {{ data.item.rawresults_date|formatDateNoH }}</b-badge>
                        <b-btn v-if="data.item.target_date" v-on:click="downloadTargets(data.item.id)" variant="default btn-xs md-btn-flat">
                            <i class="ion ion-md-cloud-download"></i>
                        </b-btn>
                        
                        
                        <b-btn v-if="data.item.rawresults_date" v-on:click="downloadRawResults(data.item.id)" variant="default btn-xs md-btn-flat">
                            <i class="ion ion-md-cloud-download"></i>
                        </b-btn>
                    </template>
                    <template :slot="$t('questions')" slot-scope="data">
                        <b-btn v-on:click="onexport(data.item.id)" variant="default btn-xs md-btn-flat">
                            {{ $t('download_question')}}
                        </b-btn>
                    </template>
                </b-table>
            </b-card-body>
            <sweet-modal width="80%" ref="formodal" height="80%">
                <form @submit="addRawResult">
                    <b-form-group label="Réponses" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                        <b-file v-model="document" ref="document"/>
                    </b-form-group>
                    <b-btn type="submit" variant="primary" slot="finish">Ajouter</b-btn>
                </form>
            </sweet-modal>
            <sweet-modal width="80%" ref="languagemodal" height="80%">
                <template v-if="$cookie.get('language') == 'en'">
                    <b-badge variant="outline-default" v-for="language in languages">{{ language.name_en }}</b-badge>
                </template>
                <template v-if="$cookie.get('language') == 'fr'">
                    <b-badge variant="outline-default" v-for="language in languages">{{ language.name }}</b-badge>
                </template>
            </sweet-modal>
        </b-card>
    </div>
</template>
<style src="@/vendor/libs/sweet-modal-vue/sweet-modal-vue.scss" lang="scss"></style>
<script>
    import {
        GET_PROVIDER_SURVEYS_REQUEST, GET_SURVEY_REQUEST,
        GET_SURVEYS_REQUEST, PROVIDER_CUSTOM_TEMPLATE_REQUEST,
        SURVEYS_ADD_RAW_RESULT_REQUEST
    } from '../_store/survey/actiontypes'
    import XLSX from 'xlsx';
    import Breadcumb from '../components/breadcumb'
    import slugify from 'slugify'
    import {SweetModal, SweetModalTab} from 'sweet-modal-vue'

    function pdfBlobConvesion(b64Data, contentType) {
        contentType = contentType || '';
        var sliceSize = 512;
        b64Data = b64Data.replace(/^[^,]+,/, '');
        b64Data = b64Data.replace(/\s/g, '');
        var byteCharacters = window.atob(b64Data);
        var byteArrays = [];

        for ( var offset = 0; offset < byteCharacters.length; offset = offset + sliceSize ) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    function getBase64(file) {
        return new Promise((resolve, reject) => {
            if (file === undefined) {
                return reject(null);
            } else {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            }
        });
    }

    export default {
        name: 'adminUserList',
        mounted() {
            this.breadcumbData = [
                { text: this.$t('your_surveys'), active: true },
            ];
            this.fields = [
                {
                    key: this.$t('label'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('survey_type'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('publication_date'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('language'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('questions'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('raw_result'),
                    sortable: false,
                    tdClass: 'align-middle'
                }
            ]
            this.$store.dispatch(GET_PROVIDER_SURVEYS_REQUEST)
                .then(response => {
                    this.surveysData = response.data.surveys
                })
        },
        components: { Breadcumb, SweetModal, SweetModalTab},
        data() {
            return {
                breadcumbData: [],
                dataUrl: 'json/pages_users_list.json',
                fields: [],
                surveysData: [],
                currentPage: 1,
                survey_id: null,
                document: null,
                languages: [],
            };
        },
        layout(context) {
            return 'layout';
        },
        methods: {
            duplicateSurvey(survey_id){
                this.$router.push('/survey/add/' + survey_id)
            },
            continueSurvey(survey_id){
                this.$router.push('/survey/edit/' + survey_id)
            },
            downloadTemplate(survey_id) {
                this.$store.dispatch(PROVIDER_CUSTOM_TEMPLATE_REQUEST, survey_id)
                    .then(response => {
                        console.log(response.data);
                        let file = response.data.encoded_string.file;
                        let type = file.split(';')[0].split('/')[1];
                        if (type == "vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                            type = "xlsx"
                        }
                        let original_type = type;
                        const linkSource = file;
                        const downloadLink = document.createElement("a");
                        const fileName = survey_id + "_template-results.xlsx";
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(pdfBlobConvesion(linkSource, original_type), fileName);
                        }
                        else {
                            downloadLink.click();
                            document.body.appendChild(downloadLink);
                        }
                    })
                    .catch(error => {
                        console.log("ERROR is ====");
                        console.log(error)
                    })
            },
            downloadRawResults(survey_id) {
                this.$store.dispatch(GET_SURVEY_REQUEST, survey_id)
                    .then(response => {
                        let survey = response.data.survey;
                        let type = survey.rawresults.split(';')[0].split('/')[1];
                        let original_type = type;
                        if (type == "vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                            type = "xlsx"
                        }
                        const linkSource = survey.rawresults;
                        const downloadLink = document.createElement("a");
                        const fileName = slugify(survey.label, '_') + "_" + survey.id + "." + type;
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(pdfBlobConvesion(linkSource, original_type), fileName);
                        }
                        else {
                            downloadLink.click();
                            document.body.appendChild(downloadLink);
                        }
                    })
                    .catch(error => {
                        console.log("ERROR is ====");
                        console.log(error)
                    })
            },
            addRawResult: function(e){
                e.preventDefault();
                getBase64(this.$refs.document.$el.querySelector('input[type=file]').files[0])
                    .then(documentB64 => {
                        this.document = documentB64;
                        this.$store.dispatch(SURVEYS_ADD_RAW_RESULT_REQUEST, {
                            "rawresults": this.document,
                            "id": this.survey_id
                        })
                            .then(() => {
                                this.$store.dispatch(GET_PROVIDER_SURVEYS_REQUEST)
                                    .then(response => {
                                        this.surveysData = response.data.surveys;
                                        this.$refs.formodal.close()
                                    })
                            })
                    })
                
            },
            onexport (survey_id) { // On Click Excel download button
                var wb = XLSX.utils.book_new();
                this.$store.dispatch(GET_SURVEY_REQUEST, survey_id)
                    .then(response => {
                        let survey = response.data.survey;
                        return Promise.all(survey.language.map(language => {
                            return Promise.all(survey.questions.map(question => {
                                return Promise.all(question.qtranslations.map(translation => {
                                    if (translation.language.id === language.id || (language.slug !== 'en' && language.slug !== 'fr' && translation.language.slug == 'en' && question.source !== 'CORE')) {
                                        if (question.is_mandatory === true)
                                            question.is_mandatory = "TRUE";
                                        if (question.is_mandatory === false)
                                            question.is_mandatory = "FALSE";
                                        let questionReturn = {
                                            'label': translation.label,
                                            'is_mandatory': question.is_mandatory,
                                            'type': ''
                                        };
                                        if (question.type === 'TFREE'){
                                            if (translation.language.slug === 'fr'){
                                                questionReturn.type = "Réponse libre"
                                            } else {
                                                questionReturn.type = "Free answer"
                                            }

                                        } else if (question.type === 'TMULT'){
                                            if (translation.language.slug === 'fr'){
                                                questionReturn.type = "Choix multiple"
                                            } else {
                                                questionReturn.type = "Multiple choice"
                                            }
                                        } else if (question.type == 'TSING') {
                                            if (translation.language.slug === 'fr'){
                                                questionReturn.type = "Choix simple"
                                            } else {
                                                questionReturn.type = "Simple choice"
                                            }
                                        }
                                        for (let index = 0; index < translation.answers.length; index++) {
                                            questionReturn['answer_' + (index + 1)] = translation.answers[index].label;
                                        }
                                        return questionReturn;
                                    }
                                }))
                                    .then(translateReturns => {
                                        return translateReturns.filter(tr => tr !== undefined)[0]
                                    })
                            }))
                                .then(questions => {
                                    console.log("I THEN QUESTIONS");
                                    console.log(questions);
                                    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(questions), language.name);
                                })
                                .catch(error => {
                                    console.log("ERROR GENERATING FILE")
                                    console.log(error);
                                })
                        }))
                            .then(() => {
                                XLSX.writeFile(wb, 'survey_'+ survey.publication_date+'_'+ slugify(survey.label, '_') + '.xlsx');
                            })
                    })
            }
        },
    };
</script>
